import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const dividerRecipeDefaultVariants = {
  "align": "center",
  "direction": "horizontal"
}
const dividerRecipeCompoundVariants = [
  {
    "align": "start",
    "direction": "horizontal",
    "css": {
      "content": {
        "pr": "md"
      }
    }
  },
  {
    "align": "start",
    "direction": "vertical",
    "css": {
      "content": {
        "pb": "md"
      }
    }
  },
  {
    "align": "center",
    "direction": "horizontal",
    "css": {
      "content": {
        "px": "md"
      }
    }
  },
  {
    "align": "center",
    "direction": "vertical",
    "css": {
      "content": {
        "py": "md"
      }
    }
  },
  {
    "align": "end",
    "direction": "horizontal",
    "css": {
      "content": {
        "pl": "md"
      }
    }
  },
  {
    "align": "end",
    "direction": "vertical",
    "css": {
      "content": {
        "pt": "md"
      }
    }
  }
]

const dividerRecipeSlotNames = [
  [
    "root",
    "Divider__root"
  ],
  [
    "content",
    "Divider__content"
  ]
]
const dividerRecipeSlotFns = /* @__PURE__ */ dividerRecipeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, dividerRecipeDefaultVariants, getSlotCompoundVariant(dividerRecipeCompoundVariants, slotName))])

const dividerRecipeFn = memo((props = {}) => {
  return Object.fromEntries(dividerRecipeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const dividerRecipeVariantKeys = [
  "align",
  "direction"
]
const getVariantProps = (variants) => ({ ...dividerRecipeDefaultVariants, ...compact(variants) })

export const dividerRecipe = /* @__PURE__ */ Object.assign(dividerRecipeFn, {
  __recipe__: false,
  __name__: 'dividerRecipe',
  raw: (props) => props,
  variantKeys: dividerRecipeVariantKeys,
  variantMap: {
  "align": [
    "center",
    "start",
    "end"
  ],
  "direction": [
    "horizontal",
    "vertical"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, dividerRecipeVariantKeys)
  },
  getVariantProps
})